<!--
Copyright (C) 2024 Checkmk GmbH - License: GNU General Public License v2
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->
<script lang="ts">
import { type PropType, defineComponent, h } from 'vue'

type HtmlString = string

export default defineComponent({
  props: {
    title: { type: String as PropType<HtmlString>, required: true }
  },
  render() {
    return h('span', { innerHTML: this.title })
  }
})
</script>

<style scoped>
/* stylelint-disable checkmk/vue-bem-naming-convention */
/* stylelint-disable-next-line selector-pseudo-class-no-unknown */
:deep(.highlight-query) {
  display: inline-block;
  background: transparent;
  color: var(--success);
  line-height: 14px;
}

span {
  &::first-letter {
    text-transform: capitalize;
  }
}
</style>
